"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensFieldsQueryGrid = void 0;
const tslib_1 = require("tslib");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const FieldFunctions_1 = require("../field/functions/FieldFunctions");
const LensFieldsDisplayGrid_1 = require("./LensFieldsDisplayGrid");
const selectConnectionListResult = (resultData) => {
    return (resultData === null || resultData === void 0 ? void 0 : resultData.lenses[0]) && resultData.lenses[0].fieldsConnection;
};
const mapResultNode = (field, resultData) => {
    return Object.assign(Object.assign({}, field.datasourceField), { dataType: 'dataType' in field.datasourceField ? field.datasourceField.dataType : null, lensId: resultData.lenses[0].vizportalUrlId, fieldIcon: (0, FieldFunctions_1.iconForField)(field.datasourceField), id: field.id, name: field.name || field.datasourceField.name, description: field.description || field.datasourceField.description });
};
function LensFieldsQueryGrid({ vizportalUrlId, orderBy, updateSortOrder }) {
    return (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.LensFieldsByIdDocument, partialQueryVariables: {
            vizportalUrlId: vizportalUrlId,
            orderBy: { field: catalog_queries_1.LensFieldOrderField.ID, direction: catalog_queries_1.OrderDirection.DESC },
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, ({ rowStore }) => (react_1.default.createElement(LensFieldsDisplayGrid_1.LensFieldsDisplayGrid, { rowStore: rowStore, orderBy: orderBy, updateSortOrder: updateSortOrder }))));
}
exports.LensFieldsQueryGrid = LensFieldsQueryGrid;
//# sourceMappingURL=LensFieldsQueryGrid.js.map